<template>
  <a class="file-link d-flex align-center rounded px-2 py-1 text-decoration-none" :href="file.Link" target="_blank"
    rel="noopener noreferrer" style="min-height: 34px; width: 100%; max-width: 100%; color: inherit;">
    <v-icon :icon="typeIcon()" size="22" class="mr-3 flex-shrink-0 text-medium-emphasis" />
    <span class="file-link__name text-break">{{ file.Name }}</span>
  </a>
</template>

<script>
export default {
  name: "File",
  props: {
    file: Object,
  },

  data() {
    return {
      DocumentTypes: {
        LINK: 1,
        FORM: 2,
        PARTDRAWING: 3,
      },
    };
  },

  methods: {
    typeIcon() {
      if (this.file.IsMedia) {
        return "mdi-file-image";
      }
      if (this.file.TypeId == this.DocumentTypes.FORM) {
        return "mdi-file-document-edit";
      }
      if (this.file.TypeId == this.DocumentTypes.PARTDRAWING) {
        return "mdi-file-cad";
      }
      return "mdi-file-document";
    },
  },
};
</script>

<style scoped>
.file-link {
  outline: none;
}

.file-link:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.file-link:focus-visible {
  box-shadow: 0 0 0 2px rgb(var(--v-theme-primary));
}

.file-link__name {
  font-size: 13px;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.87);
}
</style>
